import React, {useState} from "react";
//import Modal from 'react-modal';

import './styles.css'
import {
    Box,
    IconButton,
    Card,
    Typography,
    Grid,
    Stack,
    Button,
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';

import EscolherDatas from './EscolherDatas';

function AddNewSession(props){

    let nrSessoes = props.data.length;
    const [escolha, setEscolha] = useState(new Array(nrSessoes).fill(false));

    function handleClick(index){
        const update = escolha.map((obj,id) =>{
            //console.log(obj, id, index);
            if(id === index){
                if(escolha[index] === false){
                    return true;
                }else{
                    return false;
                }
                
            }
            return obj;
        })
        setEscolha(update);
    }

  return (props.trigger) ? (
    <Box className="popup" >
        <Box className="popup-inner" sx={{ overflow: "hidden", overflowY: "scroll"}} >
        
        <Typography variant="h5">Associar Sessão a Utente</Typography>
            <Grid container spacing={1} p={1}>
                
                {props.data.map((item, index) => (
                    <Grid item xs={4} md={4} lg={4} key={index}>
                        <Card>
                            <Box sx={{ p: 1, display:'flex' }}>
                            <Stack marginLeft={1}>
                                <Typography variant="subtitle1">{item.title}</Typography>
                                <Typography sx={{color: '#595959', height: 70, overflow: "hidden", overflowY: "scroll"}} variant="body2">{item.text}</Typography>
                            </Stack>
                            
                            </Box>
                            <Grid container paddingBottom={1}
                                direction="column"
                                alignItems="center"
                                justifyContent="center">    

                                <Grid item xs={12} md={12} lg={12}>
                                    <EscolherDatas/>
                                </Grid>

                                <Grid item xs={12} md={12} lg={12}>
                                    
                                    { 
                                    escolha[index] === false && 
                                    <Button key={index} variant="outlined" endIcon={<AddIcon/>} aria-label="add" size="small" onClick = {() => handleClick(index)}>
                                        Associar
                                    </Button>
                                    }

                                    {escolha[index]  === true && 
                                    <Button key={index}  variant="contained" endIcon={<RemoveIcon fontSize="inherit" />} aria-label="remove" size="small" onClick = {() => handleClick(index)}>
                                        Remover
                                    </Button>
                                    }
                                </Grid>
                            </Grid>
                            
                        </Card>
                    </Grid>
                ))}
            </Grid>
                    
            <LoadingButton fullWidth size="medium" type="submit" variant="contained" onClick={() => props.setTrigger(false)}>
                Confirmar Associação
            </LoadingButton>
            
            <IconButton className="close-btn" onClick={() => props.setTrigger(false)}>
                <CloseIcon/>
            </IconButton>
            {props.children}
           
        </Box>
    </Box>   
  ) : "";
}
export default AddNewSession
